import { Spinner } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import { TournamentEntryFormController } from "components/Forms/TournamentEntryForm";
import AppModal from "components/common/AppModal";
import { injectModal } from "lib/injectParams";

const NewEntryForm = TournamentEntryFormController.scope(
  ApplicationView(() => {
    const controller = TournamentEntryFormController.use();
    const { loading } = controller.state;
    const fields = Object.values(controller.fields());

    if (loading) {
      return (
        <div className="flex items-center justify-center">
          <Spinner size={64} />
        </div>
      );
    }

    return (
      <Form name="entry">
        <ModalFormFieldset fields={fields} />
        <FormButtons />
      </Form>
    );
  }),
);

const NewEntryModal: React.FC<{ id: string }> = ({ id }) => {
  return (
    <AppModal title="New entry">
      <NewEntryForm tournamentSessionId={id} attributes={{}} />
    </AppModal>
  );
};

export default injectModal(ApplicationView(NewEntryModal));
